// https://guybedford.com/es-module-preloading-integrity#modulepreload-polyfill
// import "vite/dynamic-import-polyfill";

import './base.css'

import { initializeSentry } from '@blueberry/observability/sentry'

initializeSentry({
  dsn: 'https://54ed0c6f87da55504b7a68b6169b5d0c@o213845.ingest.us.sentry.io/4508169292021760',
})

import '@hotwired/turbo'
